import { styled } from '@linaria/react';
import { breakpoints, space } from '../../theme/tokens';

export const CardGrid = styled.div<{
  $columns?: number;
  $mobileColumns?: number;
  $tabletColumns?: number;
  $flushBottom?: boolean;
  $columnGapMobile?: string;
  $rowGapMobile?: string;
  $columnGapTablet?: string;
  $rowGapTablet?: string;
}>`
  display: grid;
  grid-template-columns: repeat(${({ $mobileColumns }) => $mobileColumns ?? 1}, 1fr);
  gap: ${({ $rowGapMobile, $columnGapMobile }) =>
    `${$rowGapMobile ?? space[5]} ${$columnGapMobile ?? space[5]}`};
  margin-bottom: ${({ $flushBottom }) => ($flushBottom ? '0' : space[11])};

  @media (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(
      ${({ $tabletColumns, $columns }) => $tabletColumns ?? $columns ?? 2},
      1fr
    );
    row-gap: ${({ $rowGapTablet }) => $rowGapTablet ?? space[7]};
    column-gap: ${({ $columnGapTablet }) => $columnGapTablet ?? space[5]};
  }

  @media (min-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(${({ $columns }) => $columns ?? 2}, 1fr);
  }
`;
